// Importing React to build the component.
import React from 'react';

// Importing the Boostrap Image component.
import Image from 'react-bootstrap/Image';

// Importing the CSS file for styling the profile page.
import '../ProfilePage.css';

import { useEffect, useState } from 'react';

import APIService from '../APIService';

// ProfilePageHeader component: Displays the header for the profile page.
function ProfilePageHeader() {
        const [userData, setUserData] = useState({
                first_name: '',
                last_name: ''
            });
        
        // Fetch user data from the API using APIService
        useEffect(() => {
            const fetchUserData = async () => {
                try {
                    const data = await APIService.GetCurrentUser();
                    if (data) {
                        setUserData(data);
                    } else {
                        console.error('Failed to fetch user data');
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            };
    
            fetchUserData();
        }, []);
    return  <div className="profile-page-header-container">
                <Image className="img-fluid" src="/miami-red-background.png" alt="Miami Red Background" />
                <div className="profile-page-header-title">
                    Hello, {userData.first_name} {userData.last_name}!
                </div>
            </div>
}

// Exporting the ProfilePageHeader component so it can be imported and used in
// other parts of the app.
export default ProfilePageHeader;